import React from 'react';

const Tag = ({ children }) => (
    <span className="recipe-tag">{children}</span>
);

export default Tag; 